import { yupResolver } from "@hookform/resolvers/yup";
import { If, UploadImage } from "components";
import { MediaDirectoryKeys } from "constants/enums";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { CategorySchema } from "../../../helpers";
import { CategoryFormProps } from "./CategoryForm.types";

import styles from "./CategoryForm.module.scss";

const CategoryForm = ({
  formId,
  category,
  isMainCategory = false,
  onSubmit
}: CategoryFormProps) => {
  const { t } = useTranslation();
  const { image = null, name = "" } = category ?? {};

  const { control, handleSubmit } = useForm({
    defaultValues: {
      name,
      image
    },
    resolver: yupResolver(CategorySchema(isMainCategory))
  });

  return (
    <form
      className={styles["category-form"]}
      id={formId}
      onSubmit={handleSubmit(onSubmit)}
    >
      <If condition={isMainCategory}>
        <Controller
          control={control}
          name="image"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <UploadImage
              className={styles["category-form__image"]}
              variant="secondary"
              uploadLabel={t("Add category icon")}
              editLabel={t("Change icon")}
              deleteLabel={t("Delete icon")}
              value={value}
              onChange={onChange}
              uploadDirectoryKey={MediaDirectoryKeys.Category}
              errorMessage={error?.message}
              data-testid="category--image"
            />
          )}
        />
      </If>

      <Controller
        control={control}
        name="name"
        render={({ field, fieldState: { error } }) => (
          <Input
            label={t(`${isMainCategory ? "Category" : "Sub-category"} name`)}
            placeholder={t(
              `Enter ${isMainCategory ? "category" : "sub-category"} name`
            )}
            {...field}
            maxLength={50}
            errorMessage={error?.message}
            data-testid="category--name"
          />
        )}
      />
    </form>
  );
};

export default CategoryForm;
